import React from 'react';
export function SectionImage5() {
  return <section className="w-full" data-id="element-121">
      <img src="https://cdn.shopify.com/s/files/1/1019/9361/1596/files/hf_20260302_192819_3c3c0d23-5395-4ff8-b0a5-aa16606cbea0.png?v=1772971630" alt="Sección promocional 5" className="w-full block" style={{
      display: 'block'
    }} data-id="element-122" />
    </section>;
}